/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_AdminPsuDashboardGrantList } from '../models/PagedResultDto_AdminPsuDashboardGrantList';
import type { PagedResultDto_PsuAwardListDto } from '../models/PagedResultDto_PsuAwardListDto';
import type { PagedResultDto_UpcomingVestingGrantsDto } from '../models/PagedResultDto_UpcomingVestingGrantsDto';
import type { Wealthlane_AwardService_AppServices_PSUAwardService_DummyTestSummaryDto } from '../models/Wealthlane_AwardService_AppServices_PSUAwardService_DummyTestSummaryDto';
import type { Wealthlane_AwardService_Dtos_BulkImport_BulkImportResponseDto } from '../models/Wealthlane_AwardService_Dtos_BulkImport_BulkImportResponseDto';
import type { Wealthlane_AwardService_Dtos_BulkImport_PsuAwardImportResponseDto } from '../models/Wealthlane_AwardService_Dtos_BulkImport_PsuAwardImportResponseDto';
import type { Wealthlane_AwardService_Dtos_PerformanceRule_PerformanceRuleDetailForAdminViewDto } from '../models/Wealthlane_AwardService_Dtos_PerformanceRule_PerformanceRuleDetailForAdminViewDto';
import type { Wealthlane_AwardService_Dtos_PSUAward_ExportPSUAwardForUpdateRequestDto } from '../models/Wealthlane_AwardService_Dtos_PSUAward_ExportPSUAwardForUpdateRequestDto';
import type { Wealthlane_AwardService_Dtos_PSUAward_GetPsuGrantDetailsDto } from '../models/Wealthlane_AwardService_Dtos_PSUAward_GetPsuGrantDetailsDto';
import type { Wealthlane_AwardService_Dtos_PSUAward_PSUAwardBlobDto } from '../models/Wealthlane_AwardService_Dtos_PSUAward_PSUAwardBlobDto';
import type { Wealthlane_AwardService_Dtos_PSUAward_PSUAwardBlobRequestDto } from '../models/Wealthlane_AwardService_Dtos_PSUAward_PSUAwardBlobRequestDto';
import type { Wealthlane_AwardService_Dtos_PSUAward_PsuAwardCreationResponseDto } from '../models/Wealthlane_AwardService_Dtos_PSUAward_PsuAwardCreationResponseDto';
import type { Wealthlane_AwardService_Dtos_PSUAward_PSUAwardImportDataDto } from '../models/Wealthlane_AwardService_Dtos_PSUAward_PSUAwardImportDataDto';
import type { Wealthlane_AwardService_Dtos_PSUAward_PsuAwardImportDto } from '../models/Wealthlane_AwardService_Dtos_PSUAward_PsuAwardImportDto';
import type { Wealthlane_AwardService_Dtos_PSUAward_PsuAwardImportTemplateParseDto } from '../models/Wealthlane_AwardService_Dtos_PSUAward_PsuAwardImportTemplateParseDto';
import type { Wealthlane_AwardService_Dtos_PSUAward_PsuAwardListDto } from '../models/Wealthlane_AwardService_Dtos_PSUAward_PsuAwardListDto';
import type { Wealthlane_AwardService_Dtos_PSUAward_PSUAwardOverviewDto } from '../models/Wealthlane_AwardService_Dtos_PSUAward_PSUAwardOverviewDto';
import type { Wealthlane_AwardService_Dtos_PSUAward_PSUAwardSampleFileBlobDto } from '../models/Wealthlane_AwardService_Dtos_PSUAward_PSUAwardSampleFileBlobDto';
import type { Wealthlane_AwardService_Dtos_PSUAward_PsuAwardUpdateResponseDto } from '../models/Wealthlane_AwardService_Dtos_PSUAward_PsuAwardUpdateResponseDto';
import type { Wealthlane_AwardService_Dtos_Response_ResponseDto } from '../models/Wealthlane_AwardService_Dtos_Response_ResponseDto';
import type { Wealthlane_AwardService_Dtos_Response_ResponseDtoWithListMessage } from '../models/Wealthlane_AwardService_Dtos_Response_ResponseDtoWithListMessage';
import type { Wealthlane_AwardService_Dtos_RSUAward_AdminDashboardGrants } from '../models/Wealthlane_AwardService_Dtos_RSUAward_AdminDashboardGrants';
import type { Wealthlane_AwardService_Dtos_RSUAward_AdminDashboardGrantView } from '../models/Wealthlane_AwardService_Dtos_RSUAward_AdminDashboardGrantView';
import type { Wealthlane_AwardService_Dtos_RSUAward_AdminDashboardGrantViewRequestDto } from '../models/Wealthlane_AwardService_Dtos_RSUAward_AdminDashboardGrantViewRequestDto';
import type { Wealthlane_AwardService_Dtos_RSUAward_AwardedParticipants } from '../models/Wealthlane_AwardService_Dtos_RSUAward_AwardedParticipants';
import type { Wealthlane_AwardService_Dtos_RSUAward_AwardTransactionDetails } from '../models/Wealthlane_AwardService_Dtos_RSUAward_AwardTransactionDetails';
import type { Wealthlane_AwardService_Dtos_RSUAward_AwardTransactionDetailsByTransactionIdDTO } from '../models/Wealthlane_AwardService_Dtos_RSUAward_AwardTransactionDetailsByTransactionIdDTO';
import type { Wealthlane_AwardService_Dtos_RSUAward_GetParticipantDto } from '../models/Wealthlane_AwardService_Dtos_RSUAward_GetParticipantDto';
import type { Wealthlane_AwardService_Dtos_RSUAward_GetStatusDTO } from '../models/Wealthlane_AwardService_Dtos_RSUAward_GetStatusDTO';
import type { Wealthlane_AwardService_Dtos_RSUAward_VestingDatesSettlementTypeRequestDto } from '../models/Wealthlane_AwardService_Dtos_RSUAward_VestingDatesSettlementTypeRequestDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PsuAwardService {

    /**
     * @param sessionId 
     * @returns boolean OK
     * @throws ApiError
     */
    public static postApiAwardApiAppPSUAwardStopBulkImport(
sessionId: string,
): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/p-sUAward/stop-bulk-import/{sessionId}',
            path: {
                'sessionId': sessionId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData 
     * @returns Wealthlane_AwardService_Dtos_BulkImport_PsuAwardImportResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppPSUAwardValidateBulkPSu(
formData?: {
File?: Blob;
},
): CancelablePromise<Wealthlane_AwardService_Dtos_BulkImport_PsuAwardImportResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/p-sUAward/validate-bulk-pSU',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_PSUAward_PsuAwardCreationResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppPSUAwardPSUAwards(
requestBody?: Array<Wealthlane_AwardService_Dtos_PSUAward_PsuAwardImportTemplateParseDto>,
): CancelablePromise<Array<Wealthlane_AwardService_Dtos_PSUAward_PsuAwardCreationResponseDto>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/p-sUAward/p-sUAwards',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_PSUAward_PsuAwardCreationResponseDto OK
     * @throws ApiError
     */
    public static putApiAwardApiAppPSUAwardPSUAwardsInBulk(
requestBody?: Array<Wealthlane_AwardService_Dtos_PSUAward_PsuAwardImportTemplateParseDto>,
): CancelablePromise<Array<Wealthlane_AwardService_Dtos_PSUAward_PsuAwardCreationResponseDto>> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/p-sUAward/p-sUAwards-in-bulk',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param autoRemovePreRelease 
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_PSUAward_PsuAwardUpdateResponseDto OK
     * @throws ApiError
     */
    public static putApiAwardApiAppPSUAwardPSUAward(
autoRemovePreRelease: boolean = false,
requestBody?: Array<Wealthlane_AwardService_Dtos_PSUAward_PsuAwardImportDto>,
): CancelablePromise<Wealthlane_AwardService_Dtos_PSUAward_PsuAwardUpdateResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/p-sUAward/p-sUAward',
            query: {
                'autoRemovePreRelease': autoRemovePreRelease,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param awardId 
     * @returns Wealthlane_AwardService_Dtos_PSUAward_PSUAwardImportDataDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPSUAwardPSUAwardForUpdateById(
awardId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_PSUAward_PSUAwardImportDataDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/p-sUAward/p-sUAward-for-update-by-id/{awardId}',
            path: {
                'awardId': awardId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param approvalStatusIds 
     * @param employeeStatuses 
     * @param psuStatus 
     * @param psuAcceptance 
     * @param createdFromDate 
     * @param createdToDate 
     * @param grantFromDate 
     * @param grantToDate 
     * @param approvedFromDate 
     * @param approvedToDate 
     * @param publishFromDate 
     * @param publishToDate 
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns Wealthlane_AwardService_Dtos_PSUAward_PsuAwardListDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPSUAwardPSUAwardListOptimizedQueryable(
approvalStatusIds?: Array<number>,
employeeStatuses?: Array<number>,
psuStatus?: number,
psuAcceptance?: number,
createdFromDate?: string,
createdToDate?: string,
grantFromDate?: string,
grantToDate?: string,
approvedFromDate?: string,
approvedToDate?: string,
publishFromDate?: string,
publishToDate?: string,
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<Array<Wealthlane_AwardService_Dtos_PSUAward_PsuAwardListDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/p-sUAward/p-sUAward-list-optimized-queryable',
            query: {
                'ApprovalStatusIds': approvalStatusIds,
                'EmployeeStatuses': employeeStatuses,
                'PSUStatus': psuStatus,
                'PSUAcceptance': psuAcceptance,
                'CreatedFromDate': createdFromDate,
                'CreatedToDate': createdToDate,
                'GrantFromDate': grantFromDate,
                'GrantToDate': grantToDate,
                'ApprovedFromDate': approvedFromDate,
                'ApprovedToDate': approvedToDate,
                'PublishFromDate': publishFromDate,
                'PublishToDate': publishToDate,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param approvalStatusIds 
     * @param employeeStatuses 
     * @param psuStatus 
     * @param psuAcceptance 
     * @param createdFromDate 
     * @param createdToDate 
     * @param grantFromDate 
     * @param grantToDate 
     * @param approvedFromDate 
     * @param approvedToDate 
     * @param publishFromDate 
     * @param publishToDate 
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_PsuAwardListDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPSUAwardPSUAwardList(
approvalStatusIds?: Array<number>,
employeeStatuses?: Array<number>,
psuStatus?: number,
psuAcceptance?: number,
createdFromDate?: string,
createdToDate?: string,
grantFromDate?: string,
grantToDate?: string,
approvedFromDate?: string,
approvedToDate?: string,
publishFromDate?: string,
publishToDate?: string,
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_PsuAwardListDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/p-sUAward/p-sUAward-list',
            query: {
                'ApprovalStatusIds': approvalStatusIds,
                'EmployeeStatuses': employeeStatuses,
                'PSUStatus': psuStatus,
                'PSUAcceptance': psuAcceptance,
                'CreatedFromDate': createdFromDate,
                'CreatedToDate': createdToDate,
                'GrantFromDate': grantFromDate,
                'GrantToDate': grantToDate,
                'ApprovedFromDate': approvedFromDate,
                'ApprovedToDate': approvedToDate,
                'PublishFromDate': publishFromDate,
                'PublishToDate': publishToDate,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @deprecated
     * @param approvalStatusIds 
     * @param employeeStatuses 
     * @param psuStatus 
     * @param psuAcceptance 
     * @param createdFromDate 
     * @param createdToDate 
     * @param grantFromDate 
     * @param grantToDate 
     * @param approvedFromDate 
     * @param approvedToDate 
     * @param publishFromDate 
     * @param publishToDate 
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_PsuAwardListDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPSUAwardPSUAwardListLegacy(
approvalStatusIds?: Array<number>,
employeeStatuses?: Array<number>,
psuStatus?: number,
psuAcceptance?: number,
createdFromDate?: string,
createdToDate?: string,
grantFromDate?: string,
grantToDate?: string,
approvedFromDate?: string,
approvedToDate?: string,
publishFromDate?: string,
publishToDate?: string,
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_PsuAwardListDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/p-sUAward/p-sUAward-list-legacy',
            query: {
                'ApprovalStatusIds': approvalStatusIds,
                'EmployeeStatuses': employeeStatuses,
                'PSUStatus': psuStatus,
                'PSUAcceptance': psuAcceptance,
                'CreatedFromDate': createdFromDate,
                'CreatedToDate': createdToDate,
                'GrantFromDate': grantFromDate,
                'GrantToDate': grantToDate,
                'ApprovedFromDate': approvedFromDate,
                'ApprovedToDate': approvedToDate,
                'PublishFromDate': publishFromDate,
                'PublishToDate': publishToDate,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_PSUAward_PSUAwardBlobDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppPSUAwardGetExportPSuAward(
requestBody?: Wealthlane_AwardService_Dtos_PSUAward_ExportPSUAwardForUpdateRequestDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_PSUAward_PSUAwardBlobDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/p-sUAward/get-export-pSUAward',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param fromDate 
     * @param toDate 
     * @returns string OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPSUAwardPSUFileNameList(
fromDate?: string,
toDate?: string,
): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/p-sUAward/p-sUFile-name-list',
            query: {
                'fromDate': fromDate,
                'toDate': toDate,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData 
     * @returns boolean OK
     * @throws ApiError
     */
    public static postApiAwardApiAppPSUAwardUploadPSuAwardSample(
formData?: {
document?: Blob;
},
): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/p-sUAward/upload-pSUAward-sample',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_PSUAward_PSUAwardSampleFileBlobDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppPSUAwardDownloadPSuAwardSample(): CancelablePromise<Wealthlane_AwardService_Dtos_PSUAward_PSUAwardSampleFileBlobDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/p-sUAward/download-pSUAward-sample',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_RSUAward_GetStatusDTO OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPSUAwardPSUAwardStatuses(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_RSUAward_GetStatusDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/p-sUAward/p-sUAward-statuses',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_RSUAward_GetStatusDTO OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPSUAwardEmployeeStatuses(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_RSUAward_GetStatusDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/p-sUAward/employee-statuses',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_RSUAward_GetStatusDTO OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPSUAwardPSUStatuses(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_RSUAward_GetStatusDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/p-sUAward/p-sUStatuses',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_RSUAward_GetStatusDTO OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPSUAwardPSUAcceptances(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_RSUAward_GetStatusDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/p-sUAward/p-sUAcceptances',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_RSUAward_GetParticipantDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPSUAwardEmployeeIds(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_RSUAward_GetParticipantDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/p-sUAward/employee-ids',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_PSUAward_GetPsuGrantDetailsDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPSUAwardGrantDetails(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_PSUAward_GetPsuGrantDetailsDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/p-sUAward/grant-details',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param awardId 
     * @returns Wealthlane_AwardService_Dtos_PerformanceRule_PerformanceRuleDetailForAdminViewDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPSUAwardPerformanceRuleForAdminDetail(
awardId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_PerformanceRule_PerformanceRuleDetailForAdminViewDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/p-sUAward/performance-rule-for-admin-detail/{awardId}',
            path: {
                'awardId': awardId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_PSUAward_PSUAwardBlobDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppPSUAwardDownloadDocument(
requestBody?: Wealthlane_AwardService_Dtos_PSUAward_PSUAwardBlobRequestDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_PSUAward_PSUAwardBlobDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/p-sUAward/download-document',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param psuAwardId 
     * @returns string OK
     * @throws ApiError
     */
    public static postApiAwardApiAppPSUAwardExportPSuAwardVestingSchedule(
psuAwardId: string,
): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/p-sUAward/export-pSUAward-vesting-schedule/{PSUAwardId}',
            path: {
                'PSUAwardId': psuAwardId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppPSUAwardSendParticipantsSignUpLinks(
requestBody?: Array<string>,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/p-sUAward/send-participants-sign-up-links',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_UpcomingVestingGrantsDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPSUAwardUpcomingVestingGrants(
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_UpcomingVestingGrantsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/p-sUAward/upcoming-vesting-grants',
            query: {
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param vestingDate 
     * @param grantId 
     * @returns Wealthlane_AwardService_Dtos_RSUAward_AdminDashboardGrantView OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPSUAwardAdminDashboardGrantView(
vestingDate?: string,
grantId?: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_RSUAward_AdminDashboardGrantView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/p-sUAward/admin-dashboard-grant-view',
            query: {
                'VestingDate': vestingDate,
                'GrantId': grantId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_RSUAward_AwardedParticipants OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPSUAwardAwardedParticipants(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_RSUAward_AwardedParticipants>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/p-sUAward/awarded-participants',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_RSUAward_AdminDashboardGrants OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPSUAwardUpcomingGrantList(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_RSUAward_AdminDashboardGrants>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/p-sUAward/upcoming-grant-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param vestingDate 
     * @param grantId 
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_AdminPsuDashboardGrantList OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPSUAwardAdminDashboardGrantList(
vestingDate?: string,
grantId?: string,
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_AdminPsuDashboardGrantList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/p-sUAward/admin-dashboard-grant-list',
            query: {
                'VestingDate': vestingDate,
                'GrantId': grantId,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static deleteApiAwardApiAppPSUAwardPsuAwardById(
id: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/award/api/app/p-sUAward/psu-award-by-id/{Id}',
            path: {
                'Id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppPSUAwardCancelPsuAwardById(
id: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/p-sUAward/cancel-psu-award-by-id/{Id}',
            path: {
                'Id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns string OK
     * @throws ApiError
     */
    public static postApiAwardApiAppPSUAwardExportAdminDashboardGrantList(
requestBody?: Wealthlane_AwardService_Dtos_RSUAward_AdminDashboardGrantViewRequestDto,
): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/p-sUAward/export-admin-dashboard-grant-list',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param grantId 
     * @param input 
     * @returns Wealthlane_AwardService_Dtos_RSUAward_AwardTransactionDetails OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPSUAwardTransactionForTax(
grantId: string,
input?: string,
): CancelablePromise<Array<Wealthlane_AwardService_Dtos_RSUAward_AwardTransactionDetails>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/p-sUAward/transaction-for-tax/{GrantId}',
            path: {
                'GrantId': grantId,
            },
            query: {
                'input': input,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param transactionId 
     * @returns Wealthlane_AwardService_Dtos_RSUAward_AwardTransactionDetailsByTransactionIdDTO OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPSUAwardTransactionDetailByTransactionId(
transactionId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_RSUAward_AwardTransactionDetailsByTransactionIdDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/p-sUAward/transaction-detail-by-transaction-id/{TransactionId}',
            path: {
                'TransactionId': transactionId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_AwardService_Dtos_BulkImport_BulkImportResponseDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPSUAwardPsuBulkImportStatus(
id: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_BulkImport_BulkImportResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/p-sUAward/psu-bulk-import-status/{Id}',
            path: {
                'Id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppPSUAwardPublishPsuAward(
requestBody?: Array<string>,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/p-sUAward/publish-psu-award',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param psuVestingDateId 
     * @returns Wealthlane_AwardService_Dtos_PSUAward_PSUAwardOverviewDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPSUAwardPSUAwardDetailByPSuVestingDateId(
psuVestingDateId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_PSUAward_PSUAwardOverviewDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/p-sUAward/p-sUAward-detail-by-pSUVesting-date-id/{PSUVestingDateId}',
            path: {
                'PSUVestingDateId': psuVestingDateId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param psuVestingDateId 
     * @returns Wealthlane_AwardService_Dtos_PSUAward_PSUAwardOverviewDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPSUAwardPSUAwardDetailByPSuVestingDateIdForParticipant(
psuVestingDateId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_PSUAward_PSUAwardOverviewDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/p-sUAward/p-sUAward-detail-by-pSUVesting-date-id-for-participant/{PSUVestingDateId}',
            path: {
                'PSUVestingDateId': psuVestingDateId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDtoWithListMessage OK
     * @throws ApiError
     */
    public static deleteApiAwardApiAppPSUAwardPsuAward(
id: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDtoWithListMessage> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/award/api/app/p-sUAward/{id}/psu-award',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param awardIds 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDtoWithListMessage OK
     * @throws ApiError
     */
    public static deleteApiAwardApiAppPSUAwardPsuAwardLists(
awardIds?: Array<string>,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDtoWithListMessage> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/award/api/app/p-sUAward/psu-award-lists',
            query: {
                'AwardIds': awardIds,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param psuVestingDateId 
     * @param settlementTypeId 
     * @returns boolean OK
     * @throws ApiError
     */
    public static postApiAwardApiAppPSUAwardSetPSuVestingDateSettlementType(
psuVestingDateId?: string,
settlementTypeId?: string,
): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/p-sUAward/set-pSUVesting-date-settlement-type',
            query: {
                'psuVestingDateId': psuVestingDateId,
                'settlementTypeId': settlementTypeId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param psuVestingDateId 
     * @returns string OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPSUAwardPSUVestingDateSettlementType(
psuVestingDateId: string,
): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/p-sUAward/p-sUVesting-date-settlement-type/{psuVestingDateId}',
            path: {
                'psuVestingDateId': psuVestingDateId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param psuVestingDateId 
     * @returns boolean OK
     * @throws ApiError
     */
    public static postApiAwardApiAppPSUAwardClearPSuVestingDateSettlementType(
psuVestingDateId: string,
): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/p-sUAward/clear-pSUVesting-date-settlement-type/{psuVestingDateId}',
            path: {
                'psuVestingDateId': psuVestingDateId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppPSUAwardSetMultiplePSuVestingDateSettlementType(
requestBody?: Array<Wealthlane_AwardService_Dtos_RSUAward_VestingDatesSettlementTypeRequestDto>,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/p-sUAward/set-multiple-pSUVesting-date-settlement-type',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_AppServices_PSUAwardService_DummyTestSummaryDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPSUAwardTestSummary(): CancelablePromise<Wealthlane_AwardService_AppServices_PSUAwardService_DummyTestSummaryDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/p-sUAward/test-summary',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
